
<div class="panel-blue">
    <div class="header" [id]="headerIds" role="button" tabindex="0" [attr.aria-expanded]="isOpen"
        [attr.aria-controls]="panelIds" (click)="toggle()" (keydown)="onKeyPress($event)">
        <span class="panel-title">{{title}}</span>
        <span class="toggle-panel">
            <i class="fa" [ngClass]="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </span>
    </div>
    <div class="panel-body" *ngIf="isOpen" [id]="panelIds" role="region" [attr.aria-labelledby]="headerIds">
        <ng-content></ng-content>
    </div>

</div>